var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"employees-card",class:{
    'ma-0': _vm.noSpacing,
    'full-height': _vm.fullHeight,
    mini: _vm.mini
  }},_vm._l((_vm.employees),function(emp,i){return _c('v-row',{key:i,staticClass:"pa-0 ma-0 employee-row"},[_c('v-col',{staticClass:"pa-0 ma-0 employee-col",attrs:{"cols":"12"}},[_c('span',{staticClass:"name"},[_vm._v(" "+_vm._s(` • ${emp?.name} (${_vm.getCatNames(emp?.categories)})`)+" ")])])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }